import React, { useEffect, useState } from "react";
import { useTranslationApp } from "../../lib/i18next";
import {
  FIELD_REQUIRED,
  OPTIMIZATION_GOAL_PLACEHOLDER,
} from "../../i18n/keysTranslations";
import i18next from "i18next";
import Select from "../Form/Select";
import {
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_AWARENESS_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_TRAFFIC_OPTION,
} from "../../utils/constants";
import {
  optionsMetaOptimizationGoalAwareness,
  optionsMetaOptimizationGoalTrafficWebsite,
} from "../../utils/options";

const getOptions = (objective, destinationType) => {
  if (objective === ADS_CAMPAIGN_OBJECTIVE_AWARENESS_OPTION) {
    return optionsMetaOptimizationGoalAwareness;
  }
  if (
    objective === ADS_CAMPAIGN_OBJECTIVE_TRAFFIC_OPTION &&
    destinationType === ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION
  ) {
    return optionsMetaOptimizationGoalTrafficWebsite;
  }
  return [];
};

const SelectOptimizationGoalMeta = React.forwardRef(
  function SelectOptimizationGoalMeta(props, ref) {
    const {
      control,
      errors = {},
      rules = {
        required: {
          value: true,
          message: i18next.t(FIELD_REQUIRED),
        },
      },
      objective,
      destinationType,
      name,
      label,
      disabled = false,
      variant = "filled",
      fullWidth,
      actionsChange = () => {},
      sx = {},
    } = props;

    const [options, setOptions] = useState([]);
    const { t } = useTranslationApp();

    useEffect(() => {
      setOptions(getOptions(objective, destinationType));
    }, [objective, destinationType]);

    return (
      <Select
        ref={ref}
        control={control}
        errors={errors}
        rules={rules}
        name={name}
        label={label ?? t(OPTIMIZATION_GOAL_PLACEHOLDER)}
        disabled={disabled}
        variant={variant}
        fullWidth={fullWidth}
        options={options}
        doTranslate={true}
        actionsChange={actionsChange}
        sx={sx}
      />
    );
  }
);

export default SelectOptimizationGoalMeta;
